import { combineEpics } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import { saveAs } from 'file-saver';
import ajax from '../../shared/ajax';
import AppError from '../../shared/AppError';
import { INVALID_TOKEN_CODE } from '../../shared/constants';
import actionsAndConstants from '../../shared/actionsAndConstants';
import alertMessages from '../../shared/alertMessages';

const {
  app: { actions: appActions },
  dashboardMassUpload: {
    actions: dashboardMassUploadActions,
    constants: dashboardMassUploadConstants
  }
} = actionsAndConstants;

const exportTemplate = action$ =>
  action$.ofType(dashboardMassUploadConstants.exportTemplate)
    .mergeMap(({ payload: { ajaxOptions = {}, filename = '' } = {} }) =>
      ajax(ajaxOptions)
        .map((blob) => {
          try {
            saveAs(blob, filename);
          } catch (e) {
            throw new Error(alertMessages.export.failed);
          }
          return dashboardMassUploadActions.exportTemplateSucceeded({
            alert: {
              message: alertMessages.export.succeeded,
              type: 'success'
            }
          });
        })
        .catch((error) => {
          if (error instanceof AppError && error.code === INVALID_TOKEN_CODE) {
            return Observable.of(
              appActions.invalidToken({
                alert: { message: error.description }
              })
            );
          }
          return Observable.of(
            dashboardMassUploadActions.exportTemplateFailed({
              alert: { message: error.description || error.message || alertMessages.export.failed }
            })
          );
        }));

const uploadFile = action$ =>
  action$.ofType(dashboardMassUploadConstants.uploadFile)
    .switchMap(({ payload: { ajaxOptions = {}, dialogId = '' } } = {}) =>
      ajax(ajaxOptions)
        .mergeMap(({ descripcion }) => (
          Observable.of(
            appActions.hideDialog({ id: dialogId }),
            dashboardMassUploadActions.uploadFileSucceeded({
              alert: {
                message: descripcion || alertMessages.import.succeeded,
                type: 'success'
              }
            })
          )
        ))
        .catch((error) => {
          if (error instanceof AppError && error.code === INVALID_TOKEN_CODE) {
            return Observable.of(
              appActions.hideDialog({ id: dialogId }),
              appActions.invalidToken({
                alert: { message: error.description }
              })
            );
          }
          return Observable.of(
            appActions.hideDialog({ id: dialogId }),
            dashboardMassUploadActions.uploadFileFailed({
              alert: { message: error.description || error.message || alertMessages.import.failed },
            })
          );
        }));

export default combineEpics(
  exportTemplate,
  uploadFile
);



// WEBPACK FOOTER //
// ./src/epics/dashboard/massUpload.js